import React from "react"

const Loader: React.FC = () => {
    return (
        <>
            <div className="preloader">
                <div className="preloader_image" />
            </div>
        </>
    )
}

export default Loader;